import StatisticsPopup from './StatisticsPopup';

export default StatisticsPopup;
